import { render, staticRenderFns } from "./PageMonitoring.vue?vue&type=template&id=2f30ac10&scoped=true&"
import script from "./PageMonitoring.vue?vue&type=script&lang=js&"
export * from "./PageMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./PageMonitoring.vue?vue&type=style&index=0&id=2f30ac10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30ac10",
  null
  
)

export default component.exports